import { useMemo } from 'react';

import { useBattleCard } from 'app/contexts/battleCardProvider';
import { useTerritoryDefineAndRefine } from 'app/contexts/territoryDefineAndRefineProvider';

import { ExpandedTerritoryGroupDefineAndRefinePillData } from 'app/models';

import { getLeafNodes } from 'utils/helpers';

export function useTerritoryGroupInfos(): ExpandedTerritoryGroupDefineAndRefinePillData[] {
  const { tdrTreeLookupMap } = useTerritoryDefineAndRefine();
  const { selectedBattleCardId } = useBattleCard();
  return useMemo(() => {
    const tdrTree = tdrTreeLookupMap?.[selectedBattleCardId];
    if (tdrTree?.length) {
      const territoryGroupLeafNodes: ExpandedTerritoryGroupDefineAndRefinePillData[] = [];
      tdrTree.forEach((treeNode) => getLeafNodes(treeNode, territoryGroupLeafNodes));
      return territoryGroupLeafNodes;
    }
    return [];
  }, [tdrTreeLookupMap, selectedBattleCardId, getLeafNodes]);
}
